<template>
    <div>
        <div class="page-title-container lighter-shadow">
            <i class="fas fa-briefcase icon"></i>
            <h1>Списък на професии</h1>
        </div>
        <Grid class="grid"
              :config="config"
              :gridData="gridData"
              :loading="isLoading"
              @row-clicked="rowClicked">
        </Grid>

        <!--    Add profession form    -->
        <ProfessionEdit class="profession-edit-form" @saved-profession="refreshProfessions"/>

        <ProfessionEdit class="popup-shadow" v-if="shouldEdit" @saved-profession="savedProfession" @close-clicked="closeClicked" :profession="selectedProfession"/>
    </div>
</template>

<script>
    import Grid from "@/shared/components/grid/Grid";
    import professionGridConfig from "@/components/worker/profession-list-grid.config";
    import sharedService from "@/services/shared.service";
    import ProfessionEdit from "@/components/worker/ProfessionEdit";

    export default {
        name: "ProfessionList",
        components: {ProfessionEdit, Grid},
        created() {
            this.refreshProfessions();
        },
        data() {
            return {
                config: professionGridConfig,
                gridData: [],
                isLoading: true,
                newProfession: {
                    name: null
                },
                errors: {},
                shouldEdit: false,
                selectedProfession: null
            }
        },
        methods: {
            refreshProfessions() {
                sharedService.fetchAllProfessions()
                    .then(response => {
                        if (response.data) {
                            this.gridData = response.data;
                            this.isLoading = false;
                        }
                    });
            },
            rowClicked(row) {
                this.shouldEdit = true;
                this.$store.commit('setHasModal', true);
                this.selectedProfession = {id: row.id, name: row.name, code: row.code}
            },
            savedProfession() {
                this.refreshProfessions();
                this.selectedProfession = null;
                this.shouldEdit = false;
                this.$store.commit('setHasModal', false);
            },
            closeClicked() {
                this.selectedProfession = null;
                this.shouldEdit = false;
                this.$store.commit('setHasModal', false);
            }
        }
    }
</script>

<style scoped>
    @import '../../css/shared/tabs.css';

    .profession-edit-form {
        float: left;
        margin: 10px 100px;
    }

    .grid {
        margin-top: 30px;
        display: inline-block;
        float: left;
    }
</style>
